"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontMeasurerInfo = exports.FontMeasurer = void 0;
var html_converter_1 = require("../../rich-utils/html-converter");
var FontMeasurer = (function () {
    function FontMeasurer() {
    }
    FontMeasurer.prototype.getFontMeasurerInfo = function (font) {
        this.beginMeasuring(font);
        var baseLine = this.container.firstChild.offsetTop / this.container.lastChild.offsetHeight;
        var heightFactor = this.container.lastChild.offsetHeight / FontMeasurer.testSpanHeigth;
        this.endMeasuring();
        return new FontMeasurerInfo(baseLine, heightFactor);
    };
    FontMeasurer.prototype.beginMeasuring = function (font) {
        if (!this.container) {
            this.container = document.createElement("div");
            this.container.style.position = "absolute";
            this.container.style.top = "-10000px";
            this.container.style.left = "-10000px";
            this.container.style.opacity = "0";
            this.container.style.fontSize = "0px";
            this.container.style.lineHeight = "normal";
        }
        var fontCssString = html_converter_1.HtmlConverter.buildFontFamilyRule(font.cssString);
        this.container.innerHTML = '<span style="font-size:0; font-family: ' + fontCssString + '; display: inline-block;">A</span>' +
            '<span style="font-size:' + FontMeasurer.testSpanHeigth + 'pt; font-family: ' + fontCssString + '; display: inline-block;">A</span>';
        document.body.appendChild(this.container);
        return this.container;
    };
    FontMeasurer.prototype.endMeasuring = function () {
        if (this.container && this.container.parentNode)
            this.container.parentNode.removeChild(this.container);
    };
    FontMeasurer.testSpanHeigth = 288;
    return FontMeasurer;
}());
exports.FontMeasurer = FontMeasurer;
var FontMeasurerInfo = (function () {
    function FontMeasurerInfo(baseLine, heightFactor) {
        this.baseLine = baseLine;
        this.heightFactor = heightFactor;
    }
    return FontMeasurerInfo;
}());
exports.FontMeasurerInfo = FontMeasurerInfo;
